module.exports = __webpack_public_path__ + "static/media/alerta-taller-rojo.5cf5cd59.svg";